export const en = {
  Klantondersteuning_Formulieren_BijlageIndicatorLabel: "Attachment",
  Klantondersteuning_Formulieren_BijlagenInfoText:
    "Maximum of {{maxAmount}} attachments, maximum of 5 MB per attachment.",
  Klantondersteuning_Formulieren_BijlageInfoText:
    "Maximum of {{maxAmount}} attachment with a maximum of 5 MB.",
  Klantondersteuning_Formulieren_NakijkenEnVersturen: "Check and submit",
  Klantondersteuning_Formulieren_NoPDFButtonFound: "No PDF found.",
  Klantondersteuning_Formulieren_OpslaanAlsPdf: "Save as PDF",
  Klantondersteuning_Formulieren_RegelingOndersteuningVanuitWmo: "Social Support Act (Wmo)",
  Klantondersteuning_Formulieren_RegelingZorgVanuitDeWlz: "Long-term Care Act (Wlz)",
  Klantondersteuning_Formulieren_RegelingZorgverzekeringEnBuitenland:
    "Health insurance abroad (treaty entitled persons)",
  Klantondersteuning_Formulieren_RegelingMedicijnenMeeOpReis: "Travelling abroad with medication",
  Klantondersteuning_Formulieren_RegelingOnverzekerden: "The Uninsured",
  Klantondersteuning_Formulieren_RegelingBetalingsachterstandZorgpremie: "Healthcare premium arrears scheme",
  Klantondersteuning_Formulieren_RegelingGemoedsbezwaarden: "Conscientious objectors",
  Klantondersteuning_Formulieren_RegelingGepensioneerdenEnUitkeringsgerechtigden:
    "Pensioners and benefit recipients",
  Klantondersteuning_Formulieren_RegelingEHIC: "EHIC (European Health Insurance Card)",
  Klantondersteuning_Formulieren_RegelingBeschermdWonen: "Protected living (Wmo)",
  Klantondersteuning_Formulieren_RegelingCBHC: "Netherlands NCP Cross-Border Healthcare",
  Klantondersteuning_Formulieren_RegelingOnbekend: "I don't know",
  Klantondersteuning_Formulieren_RegelingOnverzekerbareVreemdelingen: "Uninsurable aliens",
  Klantondersteuning_Formulieren_RegelingSOV:
    "Subsidy scheme for medically necessary care for uninsured persons",
  Klantondersteuning_Formulieren_UwVraagDownloadenTekst: "Save your submitted data?",
  Klantondersteuning_Formulieren_Verzenden: "Send",
  Klantondersteuning_Formulieren_VoegBestandenToe: "Add attachments",
  Klantondersteuning_Formulieren_VoegBestandToe: "Add attachment",
  Klantondersteuning_Formulieren_FormulierVerstuurd: "Form sent",
  "Klantondersteuning_Formulieren_TextAreaInfoText{aantal}":
    "You can enter a maximum of {{aantal}} characters.",
  Klantondersteuning_Formulieren_Volgende: "Next",
  Klantondersteuning_Formulieren_NaarMijnCAKOverzicht: "To My CAK Overview"
};
